import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRouter } from 'vue-router/composables'

import VignetteLogo from "@/components/VignetteLogo.vue";
import store, { getStoreModule, SessionModule } from "@/store";
import { VignetteRoutes } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: '404',
  setup(__props) {

const sessionStore: SessionModule = getStoreModule(SessionModule, store)
const hasVignetteAccess = computed(() => sessionStore.hasVignetteAccess ?? false)
const router = useRouter()

const getHomePath = () => router.resolve({ name: VignetteRoutes.Welcome }).href
const getSearchPath = () => router.resolve({ name: VignetteRoutes.Search }).href

// @Component({
//   components: {
//     VignetteLogo,
//   },
// })
// export default class NotFoundComponent extends Vue {
//   private sessionStore!: SessionModule;
//
//   created(): void {
//     this.sessionStore = getStoreModule(SessionModule, this.$store);
//   }
//
//   getHomePath(): string {
//     return this.$router.resolve({ name: VignetteRoutes.Welcome }).href;
//   }
//
//   getSearchPath(): string {
//     return this.$router.resolve({ name: VignetteRoutes.Search }).href;
//   }
//
//   // getSignUpPath(): string {
//   //   return this.$router.resolve({ name: VignetteRoutes.SignUp }).href;
//   // }
// }

return { __sfc: true,sessionStore, hasVignetteAccess, router, getHomePath, getSearchPath, VignetteLogo }
}

})